define('services/communication/browserStation',[
    'lib/knockout',
    'jquery',
    'lib/lodash4',
    'lib/bluebird',
    'lib/SIPml-api',
    'services/loggingService'
], function (ko, $, _, Promise, SIPml, log) {
    'use strict';

    SIPml.setDebugLevel('info');

    var SIP_STACK_DEFAULTS = {
        enable_rtcweb_breaker: true,
        enable_early_ims: true,
        enable_media_stream_cache: false,
        bandwidth: null,
        video_size: null,
        sip_headers: [
            { name: 'User-Agent', value: 'IM-client/OMA1.0 sipML5-v1.2013.08.10B' },
            { name: 'Organization', value: 'ININ' }
        ]
    };

    /**
     * Idempotent SIPml setup - initalizes the engine if it hasn't been initialized yet.
     */
    function sipInit() {
        log.debug("Initializing SIPml...");
        var resolver = Promise.defer();

        if (SIPml.isInitialized()) {
            resolver.resolve();
        } else {
            SIPml.init(function () {
                resolver.resolve();
            }, function (error) {
                log.error("Error initalizing SIPml", error);
                resolver.reject(error);
            });
        }

        return resolver.promise;
    }

    function createStack(options) {
        var sipInfo = options.properties.sip.proxy[0].split(':');
        var sipIp = sipInfo[0];
        var sipPort = sipInfo[1];
        var sipId = 'sip:' + options.properties.name + '@' + sipIp;

        var resolver = Promise.defer();

        var configuration = _.extend({}, SIP_STACK_DEFAULTS, {
            realm: sipIp,
            impi: sipId,
            impu: sipId,
            display_name: options.properties.name,
            password: 'gabbaGabbaHey',  //This value doesn't matter now, but it may in the future
            websocket_proxy_url: 'ws://' + options.properties.webSocketConnection,
            outbound_proxy_url: options.properties.sip.protocol + '://' + sipIp + ':' + sipPort
        });

        log.debug('Creating SIPml stack. Configuration: \n' + JSON.stringify(configuration));
        var stack = new SIPml.Stack(configuration);

        stack.addEventListener('started', function () {
            resolver.resolve(stack);
        });

        stack.addEventListener('failed_to_start', function (event) {
            resolver.reject(event);
        });

        stack.addEventListener('*', function (event) {
            log.debug('GOT STACK EVENT\n', event);
        });

        var startStatus = stack.start();
        if (startStatus !== 0 ) {
            resolver.reject('stack start returned non-zero status ' + startStatus);
        }

        return resolver.promise;
    }

    function destroyStack(stack) {
        log.debug("Destroying sip stack...");
        var resolver = Promise.defer();

        stack.addEventListener('stopped', function () {
            resolver.resolve();
        });

        stack.addEventListener('failed_to_stop', function (event) {
            resolver.reject(event);
        });

        stack.stop();
        return resolver.promise;
    }

    function registerSession(stack) {
        log.debug("Registering Session...");
        var resolver = Promise.defer();
        var registrationSession = stack.newSession('register', {
            expires: 200,
            sip_caps: [
                { name: '+g.oma.sip-im', value: null },
                { name: '+audio', value: null },
                { name: 'language', value: '\"en\"' }  //TODO: do we need other language options?
            ]
        });

        registrationSession.addEventListener('connected', function () {
            resolver.resolve(registrationSession);
        });

        registrationSession.addEventListener('terminated', function (event) {
            resolver.reject(event);
        });

        //TODO: are there other events that should reject the promise?

        registrationSession.register();
        return resolver.promise;
    }

    function unregisterSession(registrationSession) {
        log.debug("Unregistering Session...", registrationSession);

        var resolver = Promise.defer();

        registrationSession.addEventListener('terminated', function () {
            resolver.resolve();
        });

        //TODO: Figure out if/when to reject promise

        registrationSession.unregister();
        return resolver.promise;
    }

    function initializeAudio() {
        var $sipAudio = $('<div id="rtcStation"></div>');
        var $audioElement = $('<audio autoplay="autoplay"></audio>');

        $sipAudio.append($audioElement);
        $(document.body).append($sipAudio);

        return $audioElement[0];
    }

    function teardownAudio() {
        $('#rtcStation').remove();
    }

    var sipStack = ko.observable();
    var sipSession = ko.observable();
    var callAudioElement = ko.observable();

    var browserStation = {
        selfUri: ko.observable(),

        isInitialized: ko.computed(function () {
            return sipStack() && sipSession() && callAudioElement();
        }),

        initialize: function (options) {
            if (browserStation.isInitialized()) {
                return Promise.resolve();
            } else {
                //Self Uri should report the presence URI of the station, not the config URI
                browserStation.selfUri(options.stationPresenceUri);
                return sipInit()
                        .then(function () {
                            return createStack(options);
                        })
                        .then(function (stack) {
                            sipStack(stack);
                            return stack;
                        })
                        .then(registerSession)
                        .then(function (session) {
                            sipSession(session);
                        })
                        .then(function() {
                            callAudioElement(initializeAudio());
                        });
            }
        },

        teardown: function () {
            if (!browserStation.isInitialized()) {
                return Promise.resolve();
            } else {
                return unregisterSession(sipSession())
                        .catch(function (error) {
                            log.error('Failed to unregister sip session', error);
                        })
                        .then(function () {
                            return destroyStack(sipStack());
                        })
                        .catch(function (error) {
                            log.error('Failed to destory sip stack', error);
                        })
                        .then(function () {
                            sipSession(null);
                            sipStack(null);
                            teardownAudio();
                            callAudioElement(null);
                        });
            }
        },

        makeCall: function (number) {
            if (!browserStation.isInitialized()) {
                return Promise.rejected('not inititalized');
            }

            var resolver = Promise.defer();

            var callSession = sipStack().newSession('call-audio', {
                audio_remote: callAudioElement()
            });

            callSession.addEventListener('connecting', function () {
                resolver.resolve();
            });

            callSession.addEventListener('*', function (event) {
                log.info('Call session event', event);
            });

            var callStatus = callSession.call(number);
            if (callStatus !== 0) {
                resolver.reject('Call attempt returned non-zero status ' + callStatus);
            }

            return resolver.promise;
        }
    };

    return browserStation;
});

